<template>
  <v-layout>
    <v-list-item-group style="width:100%">
      <v-dialog ref="newEmailDlg"
                v-model="showNewEmail"
                :return-value.sync="selected"
                max-width="500px"
                style="overflow-y:visible">
        <template v-slot:activator="{ on }">
          <v-autocomplete :items="addressesPlus"
                          v-model="selected"
                          :disabled="disabled"
                          item-text="address"
                          :item-value="indexOfAddress"
                          :readonly="addressesPlus.length == 1"
                          @change="$event < 0 && on.click()"
                          @click="addressesPlus.length == 1 && on.click()">
            <template v-slot:item="data">
              <v-icon v-if="data.item.icon" class="mr-2">{{data.item.icon}}</v-icon>
              <v-list-item-content>
                {{data.item.address}}
              </v-list-item-content>
            </template>
            <template v-slot:prepend-inner>
              <v-icon v-if="selectedIcon" @click="on.click()">{{selectedIcon}}</v-icon>
            </template>
          </v-autocomplete>
        </template>
        <v-card>
          <v-toolbar dense dark flat color="primary">
            <v-icon dark class="mr-2">email</v-icon>
            <v-toolbar-title>{{newEmailDlgTitle}}</v-toolbar-title>
          </v-toolbar>
          <v-alert class="mx-4 mt-2" v-if="errorMsg" type="error">
            {{errorMsg}}
          </v-alert>
          <v-tabs-items v-model="newEmailDlgMode" :touchless="true">
            <v-tab-item>
              <v-form v-model="newEmailValid">
                <v-layout column pa-4>
                  <v-flex class="pb-4">
                    <v-text-field v-model="newEmail"
                                    clearable
                                    required
                                    type="email"
                                    filled
                                    label="Email Address"
                                    autofocus
                                    autocomplete="on"
                                    :rules="verifyEmailRules"></v-text-field>
                  </v-flex>
                  <v-layout>
                    <v-btn text color="error" @click="closeDialog">Cancel</v-btn>
                    <v-spacer></v-spacer>
                    <v-btn type="submit"
                           @click.prevent="addNumber"
                           :disabled="!newEmailValid"
                           color="primary"
                           :loading="loadingApiResponse">Add email</v-btn>
                  </v-layout>
                </v-layout>
              </v-form>
            </v-tab-item>
            <v-tab-item>
              <code-verifier :to="$refs.phoneInput && $refs.phoneInput.phoneNumber || 'your number'"
                             :sends="objectToPost"
                             @error="setError"
                             @done="closeDialog"
                             @loading="setLoading"></code-verifier>
            </v-tab-item>
          </v-tabs-items>
        </v-card>
      </v-dialog>
    </v-list-item-group>
  </v-layout>

</template>

<script>
  import axios from '../plugins/axios';

  export default {
    props: [
      'addresses',
      'disabled',
      'value',
      'type'
    ],
    components: {
      CodeVerifier: () => import('./CodeVerifier'),
    },
    data: () => ({
      showNewEmail: false,
      newEmail: '',
      newEmailValid: false,
      newEmailDlgMode: 0,
      verifyEmailRules: [
        v => /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(v) || 'That doesn\'t look like a real email address',
      ],
      loadingApiResponse: false,
      errorMsg: '',
    }),
    computed: {
      user() {
        return this.$store.state.user;
      },
      passengerId() {
        return this.$store.state.passengerId;
      },
      addressesPlus() {
        return this.addresses
          .map(x => {
            x.address = x.address.toLowerCase();
            return x;
          })
          .concat({
            address: 'New email',
            icon: 'add_circle_outline'
          })
      },
      selected: {
        get() { return this.value; },
        set(v) { this.$emit('input', v); }
      },
      selectedIcon() {
        return this.addressesPlus.slice(this.selected)[0].icon
      },
      newEmailDlgTitle() {
        switch (this.newEmailDlgMode) {
          case 1: return "Verify your email address";
          default: return "Add an email address";
        }
      },
      objectToPost() {
        return {
          ContactMethodId: this.type.contactMethodId,
          PassengerId: this.passengerId,
          Address: this.newEmail
        }
      }
    },
    methods: {
      indexOfAddress(addr) {
        return this.addresses.length ? this.addresses.indexOf(addr) : 0;
      },
      closeDialog() {
        this.$refs.newEmailDlg.save(0);
        this.showNewEmail = false;
        this.errorMsg = '';
        this.newEmailDlgMode = 0;
      },
      addNumber() {
        this.loadingApiResponse = true;
        axios.post('api/VerifyAddress/' + this.user.cnxUserId, this.objectToPost).then((res) => {
          this.newEmailDlgMode = 1;
          this.errorMsg = '';
        }).catch((err) => {
          this.errorMsg = '';
          if (err.response) {
            if (err.response.status == 409) this.errorMsg = 'You can already send notifications to that email address!'
            else if (err.response.status == 401) this.errorMsg = 'You dont seem to be logged in - please refresh the page and log in again'
            else if (err.response.data && err.response.data.Message) {
              switch (err.response.data.Message) {
                case "Supplied address is unreachable":
                  this.errorMsg = 'We couldn\'t send a code to that email address. Please enter a different one';
                  break;
              }
            }
          }
          if (this.errorMsg == '') {
            this.errorMsg = 'Something went wrong. Please try refreshing the page and try again';
            console.log(err);
          }
        }).finally(() => {
          this.loadingApiResponse = false;
        });
      },
      setError(m) {
        this.errorMsg = m;
      },
      setLoading(l) {
        this.loadingApiResponse = l;
      }
    }
  };
</script>
